module.exports = __webpack_public_path__ + "assets/img/title-cc5b6779.png";